import { render, staticRenderFns } from "./Dogs.vue?vue&type=template&id=058269b8&scoped=true&"
import script from "./Dogs.vue?vue&type=script&lang=js&"
export * from "./Dogs.vue?vue&type=script&lang=js&"
import style0 from "./Dogs.vue?vue&type=style&index=0&id=058269b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058269b8",
  null
  
)

export default component.exports